import React from 'react';
import {CMSLandingTextMultipleColumns} from '@tempo/landing';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiTextMultipleColumnsBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiTextMultipleColumnsBlock: React.FC<
	StrapiTextMultipleColumnsBlockProps
> = ({strapiBlockData, translationNamespace}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<CMSLandingTextMultipleColumns
			items={strapiBlockData.textBlocks.map((block: any) => ({
				title: resolve(block.title).replace(/<[^>]+>/g, ''),
				icon: block.icon,
				text: resolve(block.content).replace(/<[^>]+>/g, ''),
			}))}
		/>
	);
};
